"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransparentPolitics = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
const OrOptions_1 = require("../../../inputs/OrOptions");
const SelectOption_1 = require("../../../inputs/SelectOption");
class TransparentPolitics {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.TRANSPARENT_POLITICS;
        this.description = 'Lose 3 delegates, reduced by influence.';
        this.revealedDelegate = PartyName_1.PartyName.POPULISTS;
        this.currentDelegate = PartyName_1.PartyName.BUREAUCRATS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const delegatesToRemove = 3 - turmoil.getPlayerInfluence(player);
            if (delegatesToRemove > 0) {
                for (let i = 0; i < delegatesToRemove; i++) {
                    game.defer(new DeferredAction_1.DeferredAction(player, () => {
                        const partiesWithPresence = turmoil.parties.filter((party) => party.delegates.includes(player.id));
                        if (partiesWithPresence.length === 0)
                            return undefined;
                        const options = partiesWithPresence.map((party) => new SelectOption_1.SelectOption('Remove delegate from ' + party.name, 'Remove delegate', () => {
                            turmoil.removeDelegateFromParty(player.id, party.name, game);
                            return undefined;
                        }));
                        return new OrOptions_1.OrOptions(...options);
                    }));
                }
            }
        });
    }
}
exports.TransparentPolitics = TransparentPolitics;
//# sourceMappingURL=TransparentPolitics.js.map